<template>
    <div class="CreateTagOption">
        <NewButton
            v-if="text.length <= maxLength"
            class="CreateTagOption__button"
            variant="flat"
            @click.stop="$emit('create', text)"
        >
            <EidIcon :icon-src="faPlus" />
            Create tag: <strong>{{ text }}</strong>
        </NewButton>
        <div v-else class="CreateTagOption__lengthError">
            Tag name must be {{ maxLength }} characters or less.
        </div>
    </div>
</template>

<style lang="scss">
.CreateTagOption {
    padding: 4px 8px;
    border-top: 1px solid var(--eidSecureBlue-25);

    &__button {
        width: 100%;
        justify-content: flex-start;
    }

    &__lengthError {
        color: var(--eidDangerRed);
        font-size: 12px;
        padding: 4px 0;
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { faPlus } from '@fortawesome/pro-light-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'CreateTagOption',
        components: { NewButton, EidIcon },
        props: {
            text: {
                type: String as PropType<string>,
                required: true,
            },
            maxLength: {
                type: Number as PropType<number>,
                default: 25,
            },
        },
        emits: [ 'create' ],
        data() {
            return {
                faPlus,
            };
        },
    });
</script>
